import { UrlParamsBuilder } from "./paramsBuilder";

export class FieldsBuilder implements UrlParamsBuilder {
  private fields: string[] | undefined;

  constructor(fields: string[] | undefined) {
    this.fields = fields;
  }

  build(urlParams: URLSearchParams): URLSearchParams {
    if (!this.fields || this.fields.length === 0) return urlParams;
    urlParams.append("fields", `(${this.fields.join(", ")})`);
    return urlParams;
  }
}


